














































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      product_id: { required },
      product_container_id: { required },
      quantity: { required },
      weight: { required },
    }

    return {
      form: rules
    }
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class WarehouseRemainForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Boolean }) fileForm!: boolean;
  @Prop({ type: Object }) initParams!: any;

  document!: any;
  form!: any;
  upload_file: any = null;

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  setProduct(product: any) {
    this.$store.dispatch(`${STORE_KEY}/setProduct`, product);
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }
  closeForm() {
    (this.$parent as any).close();
  }

  uploadFile(file: File, type: string) {
    const formData = new FormData();

    formData.append('warehouse_id', this.initParams.warehouse_id);
    formData.append('manager_id', this.initParams.manager_id);
    formData.append('file', file);

    // @ts-ignore
    this.$http.post(`/api/v1/warehouse_remains_import`,
      formData, {}
    ).then((response: any) => {
      (this.$parent as any).close();
      this.$buefy.toast.open({
        message: `Файл ${file.name} импортирован`,
        type: 'is-success'
      })
    })
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

